var hoverButton="<div class='campaign-hover-logout'><button onclick=(window.location.href='/account/login') class='button-sign-in'>SIGN IN</button><button onclick=(window.location.href='/account/register') class='button-sign-up'>SIGN UP</button></div>";
var color = null;
var newColor = null;
class CampaignGrid {
	constructor(campaignList) {
		this.campaignList = campaignList;
	}
	renderCampaignGrid() {
		this.campaignList.forEach((campaign,index)=> {
			if(campaign.id !== 523123) {
                 			$(".swell-campaign-options").append(
 					$("<div>").append(
                    	$("<div>").addClass("swell-campaign-text").append(
                        $("<i>").addClass("swell-campaign-icon"),
                        $("<h5>").text( campaign.rewardText),
                        $("<p>").text(campaign.title)   		
 						),
            //           $("<div>").addClass("swell-campaign-text-mob").append(
            //                 $("<p>").text(campaign.title),
            //                 $("<div>").text(`${campaign.rewardText}`),     
            // )

 					).attr('id', `campaign-${campaign.id}`)
 					.addClass("swell-campaign").addClass("swell-campaign-link").attr({
 						"data-campaign-id": campaign.id,
						"data-display-mode": "modal"
				}),
 			)
 		}
 		})
     // $("<div>",{
     //        id: "Buttons-hover"
     //    }).addClass("campaign-hover-logout").append(
     //        $("<button>").text("SIGN IN"),
     //        $("<button>").text("SIGN UP"))

 	
	}
	
    renderCampaignBakcgroundCssHover(customer){

         
if(customer.created_at!==undefined){
}
else {
     $(".swell-campaign").append(hoverButton);
     $(".swell-campaign").children(".campaign-hover-logout").hide();
    $(".swell-campaign").hover ( 
    function() {
        color = $(this).css("background-color");
        newColor  = `${color.substring(0, color.length - 1)},0.4)`;

         $(this).css("background-color",newColor);
        $(this).children(".campaign-hover-logout").show();
    },
    function() {

         $(this).children(".campaign-hover-logout").hide();
         $(this).css("background-color",color);

    }
    )

    }

}
   
	
}


